import { createReducer, on } from '@ngrx/store';
import { OrganizationsState } from '../../models/organizations/core.model';
import * as OrganizationsActions from '../../actions/organizations/core.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialOrganizationsState: OrganizationsState = {
  organizations: [],
};

export const organizationsReducer = createReducer(
  initialOrganizationsState,

  on(OrganizationsActions.loadOrganizationsSuccess, (state, { organizations }) => ({
    ...state,
    organizations
  })),

  on(OrganizationsActions.loadOrganizationByIdSuccess, (state, { organization }) => {
    const exists = state.organizations.some(org => org.data.id === organization.data.id);
    return {
      ...state,
      organizations: exists 
        ? state.organizations.map(org => org.data.id === organization.data.id ? organization : org)
        : [...state.organizations, organization]
    };
  }),

  on(OrganizationsActions.createOrganizationSuccess, (state, { organization }) => ({
    ...state,
    organizations: [...state.organizations, organization]
  })),

  on(OrganizationsActions.updateOrganizationSuccess, (state, { organization }) => ({
    ...state,
    organizations: state.organizations.map(org =>
      org.data.id === organization.data.id ? organization : org
    )
  })),

  on(OrganizationsActions.deleteOrganizationSuccess, (state, { id }) => ({
    ...state,
    organizations: state.organizations.filter(org => org.data.id !== id)
  })),

  // Reset organizations state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialOrganizationsState)
);